import { GeoJsonProperties } from 'geojson';

export type CoordinatesType = {
    lat: number | null;
    lng: number | null;
};

export type MapPointType = {
    lat: number;
    lng: number;
};

export type MapMarkerType = MapPointType & {
    identifier: string;
    storeName?: string;
    storeStreet?: string;
    storeCity?: string;
    storeSlug?: string;
    isPickupPoint?: boolean;
    postOffice?: boolean;
};

export enum MapProviderTypeEnum {
    OSM = 'open_street_map',
    SEZNAM = 'mapy_cz',
    GOOGLE = 'google_maps',
}

export interface MapProps {
    markers: MapMarkerType[];
    clickOnMarkerHandler?: (uuid: string) => void;
    shouldShowSpinner?: boolean;
    shouldChangeFitToBounds?: boolean;
    minimumFitToBoundsZoom?: number;
    clusterRadius?: number;
}

export type SuperclusterClusterMarkerType = GeoJsonProperties &
    MapMarkerType & {
        cluster: boolean;
        point_count: number;
        id: number;
    };

export type SuperclusterPointMarketType = GeoJsonProperties & MapMarkerType;
